/** TODO: remove this component and use chegg-ui's menu/popover component when available */
import React, { FunctionComponent, useLayoutEffect } from 'react'
import { Tooltip, TooltipProps } from '@chegg-ui/tooltip'
import styled from 'styled-components'
import { font } from '@chegg-ui/theme'

const POPOVER_MENU = 'popover-menu'

const Menu = styled(Tooltip)`
  z-index: 1000;
  & > div[role='navigation'] {
    padding: 0;
    font-weight: ${font.weight.normal};
    box-shadow: none;
    background-color: transparent;
    top: unset;
  }

  & > div[role='navigation']:before {
    border-bottom-color: transparent;
  }

  & > div[role='navigation']:after {
    border-bottom-color: transparent;
  }
`

const PopoverMenu: FunctionComponent<TooltipProps> = ({ targetElement, children }) => {
  useLayoutEffect(() => {
    const tooltipElement = document?.querySelector(`.${POPOVER_MENU} > [role="tooltip"]`)
    tooltipElement?.setAttribute('role', 'navigation')
  }, [])
  return (
    <Menu className={POPOVER_MENU} targetElement={targetElement}>
      {children}
    </Menu>
  )
}

export default PopoverMenu
